import { useQuery } from '@apollo/client/react';
import { DatePicker } from '@optools/components/datetime/date-picker';
import { GameSchedule } from '@optools/components/game-schedule';
import { SportSelect } from '@optools/components/sport-select';
import { MILESTONES_SCHEDULE } from '@optools/services/operator-gateway/milestones/queries';
import { Sport } from '@optools/services/operator-gateway/types/generated/graphql';
import { MilestonesGameCard } from '@optools/tools/milestones/components/milestones-game-card';
import { milestonesScheduleSchema } from '@optools/tools/milestones/schemas/schedule';
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_auth/milestones/')({
  component: RouteComponent,
  validateSearch: zodValidator(milestonesScheduleSchema),
});

export function RouteComponent() {
  const { date, sport } = useSearch({ from: '/_auth/milestones/' });
  const navigate = useNavigate({ from: Route.fullPath });

  const handleDateChange = (newDate: string) => {
    return navigate({ search: (search) => ({ ...search, date: newDate }) });
  };

  const handleSportChange = (value: Sport) => {
    return navigate({ search: (search) => ({ ...search, sport: value }) });
  };

  const { data, loading } = useQuery(MILESTONES_SCHEDULE, {
    variables: { date, sports: [sport] },
  });

  return (
    <GameSchedule
      loading={loading}
      render={(game) => <MilestonesGameCard key={game.gamePk} date={date} game={game} />}
      schedule={data?.schedule}>
      <SportSelect value={sport} onValueChange={handleSportChange} />
      <DatePicker date={date} disabled={loading} setDate={handleDateChange} />
    </GameSchedule>
  );
}
